import { render, staticRenderFns } from "./layout-product-data.vue?vue&type=template&id=37a7d8a6&scoped=true&"
import script from "./layout-product-data.vue?vue&type=script&lang=js&"
export * from "./layout-product-data.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-data.vue?vue&type=style&index=0&id=37a7d8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7d8a6",
  null
  
)

export default component.exports